import axios from "axios";
import { GURL } from "./global";

export const CreateInvitation = (model: any) => {
  const url = `${GURL}/Company/v1/Invitations/CreateInvitation`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};

export const GetInvitationByInvitationId = (Id: any) => {
  const url = `${GURL}/Company/v1/Invitations/GetInvitationByInvitationId?InvitationId=${Id}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetInvitationsByCompanyName = (name: string) => {
  const url = `${GURL}/Company/v1/Invitations/GetInvitationsByCompanyName?companyName=${name}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetMyInvitations = () => {
  const url = `${GURL}/Company/v1/Invitations/MyInvitations`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const UpdateInvitation = (model: any) => {
  //console.log("m", model);

  const url = `${GURL}/Company/v1/Invitations/UpdateInvitation`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};

export const InvitationAcceptByInvitationCode = (
  invitationCode: any,
  phoneNumber: any
) => {
  //console.log("m", model);

  const url = `${GURL}/Company/v1/Invitations/InvitationAcceptByInvitationCode?InvitationCode=${invitationCode}&PhoneNumber=${phoneNumber}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url);
};

export const SendInvitationSms = (InvitationId: any) => {
  //console.log("m", InvitationId);
  const url = `${GURL}/Company/v1/Invitations/SendInvitationSms`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, { InvitationId: InvitationId });
};

export const SendInvitationEmail = (InvitationId: any) => {
  //console.log("m", InvitationId);

  const url = `${GURL}/Company/v1/Invitations/SendInvitationEmail`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, { InvitationId: InvitationId });
};

export const CheckInvitationWithPhoneNumber = (
  PhoneNumber: any,
  InvitationCode: any
) => {
  const url = `${GURL}/Company/v1/Invitations/CheckInvitationWithPhoneNumber?PhoneNumber=${PhoneNumber}&&InvitationCode=${InvitationCode}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetInvitationByInvitationCode = (InvitationCode: any) => {
  const url = `${GURL}/Company/v1/Invitations/GetInvitationByInvitationCode?InvitationCode=${InvitationCode}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("1")}`;
  return axios.get(url);
};
